skrilla.controller('cancelBetModalCtrl', function ($scope, searchService, modalService, cacheService) {
    $scope.bet = cacheService.getObjectOrElse("betDetails", function(){modalService.dismissAll()});
    $scope.unvoid = $scope.bet.status === "VOID";
    const un = $scope.unvoid ? "un" : "";

    $scope.cancel = function(){
        //break this into cancel modal
        modalService.confirm(`Are you sure you'd like to ${un}void this bet?`, function(){
            searchService.put(`bets/${$scope.bet.id}/${un}cancel`, {message: $scope.message},
                `Bet ${un}void requested. This is a background process that may take some time to complete.`).then(function(response){
                modalService.dismissAll();
            });
        });
    }

});